module.exports = __webpack_public_path__ + "static/media/b_3bhk_4.9df53593.jpg";